module.exports = __webpack_public_path__ + "static/media/hustle.e9645293.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/FoldHome/assets/hustle.png
// module id = 460
// module chunks = 0